import { hexToRgb } from 'assets/jss/material-dashboard-pro-react';
import cx from 'classnames';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { ButtonBase, Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';

import AdvertisingIcon from 'components/CustomIcons/AdvertisingIcon';
import { useDataFilterContext } from 'components/DataMap/DataFilterProvider';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import SimpleModalHeader from 'components/SimpleModalHeader/SimpleModalHeader';

const useStyles = makeStyles((theme) => ({
  cards: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',

    '& > div': {
      display: 'flex',
      width: '50%',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },

  mailCampaignButton: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.fullFarm.main)}, 0.2)`,
    border: `2px solid ${theme.palette.fullFarm.main}`,
    '& svg': {
      color: theme.palette.fullFarm.main,
    },
  },
  digitalAdButton: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.commercial.main)}, 0.2)`,
    border: `2px solid ${theme.palette.commercial.main}`,
    '& svg': {
      color: theme.palette.commercial.main,
    },
  },

  button: {
    flex: 1,
    width: '100%',
    maxWidth: '242px',
    display: 'flex',
    flexDirection: 'column',

    margin: '9px',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0px 0px 0px 1px rgba(26, 26, 26, 0.24), 0px 4px 8px -2px rgba(32, 37, 50, 0.2)',

    '&:hover': {
      boxShadow: '0px 0px 0px 1px rgba(26, 26, 26, 0.24), 0px 4px 8px -2px rgba(32, 37, 50, 0.4)',
    },
  },
  buttonTop: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',

    '& > h4': {
      marginLeft: '10px',
      flex: 1,
      textAlign: 'center',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600,
      color: theme.palette.black.main,
    },
  },
  buttonLine: {
    width: '100%',
    maxWidth: '175px',

    margin: '12px 32px',
    borderBottom: `1px solid ${theme.palette.black.main}`,
  },
  buttonBottom: {
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '19px',
    color: theme.palette.darkGray.main,
  },
}));

const SelectCampaignEventTypeModal = ({ onClose }) => {
  const classes = useStyles();
  const history = useHistory();
  const { availableEventTypes } = useDataFilterContext();

  const onSelectEventType = (eventType) => {
    history.push({ pathname: '/dashboard/create-campaign', state: { eventType } });
  };

  const onCreateAdCampaign = async () => {
    history.push('/dashboard/ad-campaigns/create');
  };

  const fullFarmEventType = availableEventTypes.find(({ name }) => name === 'Full Farm');

  return (
    <Dialog
      open
      scroll="body"
      keepMounted
      maxWidth="sm"
      onClose={onClose}
    >
      <SimpleModalHeader onClose={onClose} title="Select Type" />

      {availableEventTypes.length > 0 ? (
        <div className={classes.cards}>
          {fullFarmEventType && (
            <div>
              <ButtonBase onClick={() => onSelectEventType(fullFarmEventType)} className={cx(classes.button, classes.mailCampaignButton)}>
                <div className={classes.buttonTop}>
                  <MailOutlinedIcon />
                  <h4>Mail</h4>
                </div>
                <div className={classes.buttonLine} />
                <div className={classes.buttonBottom}>
                  {`${fullFarmEventType.campaignLengthInMonths} months / ${fullFarmEventType.numberOfTouchesPerEvent} touches`}
                </div>
              </ButtonBase>
            </div>
          )}

          <div>
            <ButtonBase onClick={onCreateAdCampaign} className={cx(classes.button, classes.digitalAdButton)}>
              <div className={classes.buttonTop}>
                <AdvertisingIcon />
                <h4>Digital Ad</h4>
              </div>
              <div className={classes.buttonLine} />
              <div className={classes.buttonBottom}>
                month-to-month
              </div>
            </ButtonBase>
          </div>
        </div>
      ) : <LoadingIndicator />}
    </Dialog>
  );
};

export default SelectCampaignEventTypeModal;
